// Rare, legendary and cursed charm icons (24×24, id charm_<id>). 1-px ink outline, light from top-left.
// Legendaries lean gold/lavender and carry a floating sparkle glint; cursed charms carry crimson accents.
// Key: '.' transparent, 'o' ink outline, other chars per sprite.
import { sprite, type SpriteDef } from './types';

// ---- Rare

export const charmGoldengrin = sprite(
  'charm_goldengrin',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    b: 'brick',
    w: 'white',
    p: 'paper',
    s: 'steel',
    W: 'wine',
    r: 'red',
    R: 'blood',
    m: 'maroon',
  },
  [
    '........................',
    '...........oo...........',
    '........ooowrooo........',
    '......oolllrRgggoo......',
    '.....olllllggggggao.....',
    '....ollllllgggggaaao....',
    '.oo.olllllggggggaaao.oo.',
    'orRolloooggggggoooaaoRmo',
    '.oroloooooggggoooooaomo.',
    '..oogogggoggagoaaaocoo..',
    '..ooggggggggcgaaaaacoo..',
    '.orogolggggggaaaaaocomo.',
    '.oroolooogggaaaooopoomo.',
    'orRo.opwpoooooowpwo.oRmo',
    '.oo..opwpwpwpwpwpwo..oo.',
    '....oaopWwpwpwpWsoco....',
    '.....oaosWWWWWWpoco.....',
    '.....oaaopspspsocbo.....',
    '......oaaoooooocbo......',
    '......oaaccccccbbo......',
    '.......occccccbbo.......',
    '........oocbbboo........',
    '..........oooo..........',
    '........................',
  ],
);

export const charmSecondmouth = sprite(
  'charm_secondmouth',
  {
    o: 'ink',
    l: 'lemon',
    r: 'brass',
    b: 'bronze',
    c: 'copper',
    k: 'brick',
    f: 'flesh',
    s: 'salmonPink',
    e: 'cerise',
    W: 'wine',
    w: 'white',
    p: 'paper',
    t: 'coral',
  },
  [
    '........oooooooo........',
    '......oorcrcrcrcoo......',
    '.....ocrcoooooorcro.....',
    '.....oroo.orro.ooco.....',
    '.....ocooorooboooro.....',
    '......ocroroobocro......',
    '.......ocrcrcrcro.......',
    '......oolllllllroo......',
    '.....olllllllllrrro.....',
    '....olllootttsoorrbo....',
    '...olllottttttssorbbo...',
    '...ollotttoooossfobbo...',
    '..olllttoopwpwooffbbco..',
    '..ollotopwWWWWpwofobco..',
    '..ollotoWWWWWWWWoeocco..',
    '..orlosoWWWWeeoWeoocco..',
    '..orrrssopwpwpweeoccko..',
    '...orroffoooooeeoocko...',
    '...obrrofffoeeeoockko...',
    '....obbbooeeoooockko....',
    '.....obbbbbbcccckko.....',
    '......oocccccckkoo......',
    '........oooooooo........',
    '........................',
  ],
);

export const charmCrookedlever = sprite(
  'charm_crookedlever',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    r: 'brass',
    a: 'amber',
    c: 'copper',
    w: 'white',
    C: 'coral',
    R: 'red',
    B: 'blood',
    m: 'maroon',
    d: 'dusk',
    s: 'steel',
    L: 'lilacGrey',
    k: 'brick',
  },
  [
    '...............oo.......',
    '.............ooCCoo.....',
    '............owwwCCRo....',
    '...........owwwCCRRRo...',
    '...........owwCCCRRBo...',
    '..........oCCCCCRRRBmo..',
    '..........oRCCRRRRBBmo..',
    '...........oRRRRRBBmo...',
    '...........oRRRBBBBmo...',
    '............oBBBBmmo....',
    '..........ooooommoo.....',
    '.........ollllgoo.......',
    '........oggggggao.......',
    '.......olaaaagao........',
    '.......olgaaaao.........',
    '......olgaaooo..........',
    '....ooolgaoo............',
    '...osolgaaoLo...........',
    '..osssogaoLLdo..........',
    '.oossssooLLddoo.........',
    'olllrrrrrrraaaao........',
    'occoccccccckokko........',
    '.oo.oooooooo.oo.........',
    '........................',
  ],
);

export const charmSurgeonkit = sprite(
  'charm_surgeonkit',
  {
    o: 'ink',
    n: 'night',
    d: 'dusk',
    l: 'lilacGrey',
    c: 'charcoal',
    r: 'brass',
    b: 'bronze',
    g: 'gold',
    a: 'amber',
    w: 'white',
    p: 'paper',
    s: 'steel',
    R: 'red',
    B: 'blood',
  },
  [
    '....................o...',
    '...................owo..',
    '..................owRo..',
    '.........oooo....owpBo..',
    '........oldddo....ooo...',
    '.......ollddddo..opso...',
    '......oddooooddo.opso...',
    '......oddo..oddoopso....',
    '.......oooooooooopso....',
    '.....ooolllddddopsso....',
    '....ollllldddddopsoo....',
    '..oolllllddggdopssonoo..',
    '.orggggggggrrbrosobbbao.',
    '.olllllddddbbdnnonnncco.',
    '.olllldddddddnnnnnnncco.',
    '.ollldddddddnnnnnncccco.',
    '.olllddddddnnnnnnccncco.',
    '.oldddddddnnnnnncccccco.',
    '.oddlddddnnnnnnccccncco.',
    '.oddddddnnnnnncccccccco.',
    '..oodddnnnnnncccccccoo..',
    '....ooonnnnncccccooo....',
    '.......oooooooooo.......',
    '........................',
  ],
);

export const charmSandpendant = sprite(
  'charm_sandpendant',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    w: 'white',
    i: 'ice',
    n: 'navy',
    I: 'indigo',
    r: 'brass',
    b: 'bronze',
    C: 'cream',
  },
  [
    '...........oo...........',
    '..........oggo..........',
    '.........ogooao.........',
    '..........oaao..........',
    '.........oooooo.........',
    '.....oooollggggoooo.....',
    '....ollllggggggaaaao....',
    '....oaaaaaaaaaacccco....',
    '.....olooooooooooao.....',
    '.....olownnnIIIIoao.....',
    '.....oloinnrrIIooao.....',
    '.....ogoooCrrro.oao.....',
    '.....ogo..orro..oao.....',
    '.....ogo..orro..oao.....',
    '.....ogo..oCro..oao.....',
    '.....ogo..orIo..oao.....',
    '.....ogo.onCrIo.oao.....',
    '.....ogooiCrrrbooao.....',
    '.....ogoiCCrrrbboao.....',
    '.....ogooooooooooao.....',
    '....ollllggggggaaaao....',
    '....oaaaaaaaaaacccco....',
    '.....oooooooooooooo.....',
    '........................',
  ],
);

export const charmVoodoo = sprite(
  'charm_voodoo',
  {
    o: 'ink',
    k: 'khaki',
    s: 'sand',
    m: 'mauveGrey',
    d: 'mud',
    R: 'red',
    B: 'blood',
    t: 'steel',
    g: 'gold',
    G: 'lemon',
    i: 'mint',
    I: 'neonTeal',
    c: 'cobalt',
    b: 'blue',
    C: 'coral',
  },
  [
    '..................oo....',
    '...........oo....oCRo...',
    '.........ookkoo..oRBo...',
    '........okmkkkkooooo....',
    '.......okkkkkksotto.....',
    '.......okokkkkotoo......',
    '......okokkkkbcoco.oo...',
    '.......okokkssccmooGGo..',
    '......okkksssssdmooggo..',
    '......osodododommotoo...',
    '.......osssssmmmoto.....',
    '.....o.okddddddotoo.....',
    '...ooookkkssssotoodoo...',
    '..okotokkCRsRotomdmmmo..',
    '...otookkRRRotommomoo...',
    '...oto.ossRRBommo.o.....',
    '..oto..osssBBmdmo.......',
    '.ooto..osmsmmmmmo.......',
    'oiIo...ossmmdmmmo.......',
    'oIIo...osmmoomdmo.......',
    '.oo....omdmoommmo.......',
    '........ommoommo........',
    '.........oo..oo.........',
    '........................',
  ],
);

export const charmCrystalball = sprite(
  'charm_crystalball',
  {
    o: 'ink',
    w: 'white',
    S: 'sky',
    b: 'blue',
    c: 'cobalt',
    i: 'indigo',
    n: 'navy',
    v: 'lavender',
    P: 'pinkLilac',
    l: 'lemon',
    r: 'brass',
    B: 'bronze',
    C: 'copper',
    k: 'brick',
    V: 'violet',
  },
  [
    '........................',
    '........oooooooo........',
    '.......oSSSSbbbco.......',
    '......oSSSSSbbbcco......',
    '.....oSwwSSbbbbccco.....',
    '....oSwSSSSbbbbcccio....',
    '...obSwSSSbbbbcccciio...',
    '...obSSSbbbbbccccciio...',
    '...obbbbbVVVVcccciiio...',
    '...obbbbVbPPvVccciiio...',
    '...obbbVbPccvcVciiiio...',
    '...ocbbVcvvcvcciiiino...',
    '...occccVccvVciiiinno...',
    '...occcccVVViiiiibnno...',
    '....occccciiiiiibnno....',
    '.....oiioooooooonno.....',
    '......oolllllllroo......',
    '.....olllllllllrrBo.....',
    '.....ollllllllrrrBo.....',
    '.....ooolrrrCCCBooo.....',
    '....ollrrrBBBBBCCCCo....',
    '....oCCCCCCCCkkkkkko....',
    '.....oooooooooooooo.....',
    '........................',
  ],
);

export const charmRatking = sprite(
  'charm_ratking',
  {
    o: 'ink',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    d: 'dusk',
    k: 'salmonPink',
    K: 'dustyPink',
    f: 'flesh',
    r: 'red',
    w: 'white',
    g: 'gold',
    G: 'lemon',
    a: 'amber',
    R: 'red',
    B: 'blood',
    W: 'wine',
    c: 'cobalt',
    m: 'rose',
  },
  [
    '........o..o..o.........',
    '.......oGooGoogo........',
    '.......oGgoGgogo........',
    '....ooooGggggggooooo....',
    '...opppogRggcggoppppo...',
    '..oppppoaaaaaaaoppppso..',
    '..oppkkoooooooosokkkso..',
    '..oppkopppppppsssokkso..',
    '..oppopppppppssssloklo..',
    '...osoppppppssssllolo...',
    '....ooppwpsssswllloo....',
    '.....ossBsllldBdddo.....',
    '.....ossssllldddddo.o...',
    '.....lossslllddddoloKo..',
    '....l.oolllffdddoooKo...',
    '.....owwooollooowwwoo...',
    '....owwwowowwowwwwooKo..',
    '.....oRRRBBooBBWWWo.oKo.',
    '....oRRRRBBrBBBWWWWoomo.',
    '....oRRRRBBrBBBWWWWoomo.',
    '...oRRRRRBBrBBBWWWWWoo..',
    '...oRRRRRBBrBBBWWWWWo...',
    '..oRRRRRRBBrBBBWWWWWWo..',
    '...oooooooooooooooooo...',
  ],
);

export const charmBloodbank = sprite(
  'charm_bloodbank',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    C: 'coral',
    r: 'red',
    b: 'blood',
    W: 'wine',
  },
  [
    '........................',
    '.....oooooo..oooooo.....',
    '....owpppppoopppssso....',
    '....ossssssssssllllo....',
    '....ossssssssslllllo....',
    '....oCCrrrrbbbbWWWWo....',
    '....oCwwrrrbbbbWWWWo....',
    '....oCwrrrrbbbbWWWWo....',
    '....oCCrrwwwwwwwwWWo....',
    '....oCCrrwrrrrbbsWWo....',
    '....oCCrrwppppppsWWo....',
    '....oCCrrwlllllpsWWo....',
    '....oCCrrwlllpppsWWo....',
    '....oCCrrwsssssssWWo....',
    '....oCCrrrrbbbbWWWWo....',
    '.....orCrrrbbbWWWWo.....',
    '.....orrrrbbbbWWWWo.....',
    '......oorbbbbWWWooooo...',
    '........ooobWoooooppso..',
    '..........oooo.obowpso..',
    '..........oboooboopsso..',
    '...........obbbo..ooo...',
    '............ooo.........',
    '........................',
  ],
);

export const charmRecipe = sprite(
  'charm_recipe',
  {
    o: 'ink',
    w: 'white',
    c: 'cream',
    a: 'apricot',
    s: 'sand',
    l: 'lilacGrey',
    r: 'red',
    b: 'blood',
    p: 'paper',
    t: 'steel',
    m: 'maroon',
  },
  [
    '................o.o.o...',
    '...............owowopo..',
    '...............owopolo..',
    '..oooooooooooo.owopolo..',
    '.owwwwwwwwwwwwoowopolo..',
    '.owcccccccccccsowopolo..',
    '.owcrrbrrbrccccowopolo..',
    '.owccccccccccccowpptlo..',
    '.owccccccccccccaoppto...',
    '.owclllllllllccaoppto...',
    '.owccccccccccccaoopo....',
    '.owclllllllccccaoopo....',
    '.owccccccccccccaoppto...',
    '.owclllllllllccaoppto...',
    '.owccccccccccccaoppto...',
    '.owcllllllcccccaoptto...',
    '.owccccccccccccaoppto...',
    '.owcrbcccccccccaoppto...',
    '.owcbbmcrccccccaoptto...',
    '.owccccccccccccaoppto...',
    '.owaaaaaaaaaaaaaoppto...',
    '..oooooooooooooo.opo....',
    '..................o.....',
    '........................',
  ],
);

export const charmVisor = sprite(
  'charm_visor',
  {
    o: 'ink',
    L: 'leaf',
    c: 'clover',
    f: 'forest',
    P: 'pine',
    k: 'pistachio',
    r: 'brass',
    a: 'amber',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    e: 'celadon',
    g: 'sage',
    m: 'mint',
  },
  [
    '........................',
    '........................',
    '..........oooo..........',
    '.......ooowwwpooo.......',
    '....oooooooooooooooo....',
    '...oLLLLLffffffPPPPPo...',
    '...offfffffffPPPPPPPo...',
    '.ooLLLLccccccffffffffoo.',
    'okkkLLLLLLcccccffffffffo',
    'orrkkkkLLLLLLcccccfffaao',
    '.oorrkkkkkLLLLLccccaaoo.',
    '...oorrrrrrraaaaaaaoo...',
    '...oeoooooooooooooogo...',
    '....opoomossssoomolo....',
    '....osoooossssoooolo....',
    '.....osoosssssloolo.....',
    '......ossssoollllo......',
    '.......opppsosllo.......',
    '.......opoposollo.......',
    '........oooooooo........',
    '........opososo.........',
    '.........o.o.o..........',
    '........................',
    '........................',
  ],
);

export const charmPinball = sprite(
  'charm_pinball',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    d: 'dusk',
    G: 'lemon',
    g: 'gold',
    a: 'amber',
  },
  [
    '........................',
    '........................',
    '.................oo.....',
    '.........oooo...oGGo....',
    '......ooopppsooooGgooo..',
    '.....owwwwpppoGGGgggaao.',
    '....owwwwwppppoGgggaao..',
    '...owwwwwpwppssoggaao...',
    '..opwwwwpppppssogaaao...',
    '..opwwwpppppssogaooaao..',
    '..oppppppppssssoolloo...',
    '.oppppppppssssssllldo...',
    '.opppppppsssssslllldo...',
    '.osppppsssssssllllddo...',
    '.ossssssssssslllllddo...',
    '..ossssssssllllllddo....',
    '..ossssssslllllldddo....',
    '..olssslllllllldsddo....',
    '...olllllllllldsddo.....',
    '....olllllllssdddo......',
    '.....odlldddsdddo.......',
    '......oooddddooo........',
    '.........oooo...........',
    '........................',
  ],
);

export const charmWheelgrease = sprite(
  'charm_wheelgrease',
  {
    o: 'ink',
    l: 'lemon',
    r: 'brass',
    b: 'bronze',
    c: 'copper',
    k: 'brick',
    n: 'night',
    d: 'dusk',
    w: 'white',
  },
  [
    '........................',
    '...................oo...',
    '.................oolbo..',
    '................ollbbo..',
    '...............olbbbodo.',
    '.............oolbboowdo.',
    '............ollbbo.onno.',
    '........oooolbboo...oo..',
    '.......olrrbobo.........',
    '.......olrrboo..........',
    '.......orbbco...........',
    '.......orbbco...........',
    '......olrbbcco..........',
    '.....oolrbbccoo.........',
    '...oolllrbbcckboo.......',
    '..ollllllrrrrbbbbo......',
    '..occcccccccckkkko......',
    '..olllrrkkkbccckko......',
    '..olllrkkbkkccckko......',
    '..olllrkrkbkccckko......',
    '..olllrkkbkkccckko......',
    '...ollrrkkkbcccko.......',
    '....oooorbbboooo........',
    '........oooo............',
  ],
);

export const charmScratchcoin = sprite(
  'charm_scratchcoin',
  { o: 'ink', w: 'white', p: 'paper', s: 'steel', l: 'lilacGrey', d: 'dusk' },
  [
    '........................',
    '.........oooooo.........',
    '.......oowwwwoooo.......',
    '......owwwwwwwpodo......',
    '.....owwwwppwpppolo.....',
    '....owwwpppssspppodo....',
    '...owwwpppsssssppollo...',
    '...owwpppwwwssssppodo...',
    '...owpppwwdddssspsolo...',
    '..owwpppsddwddsspsoddo..',
    '..owwppssswwddsllsoolo..',
    '..owwpsssswddslllswodo..',
    '..owwpsssssdsslllssolo..',
    '..owwssssswssllllsoddo..',
    '..owwssssssdllllssollo..',
    '...owsssssslllllswodo...',
    '...oppssssllllllssolo...',
    '...opppssslllllssoddoo..',
    '....opppslllllsswoloplo.',
    '.....opppsllssssodo.oo..',
    '......opsssssssoloo.....',
    '.......oossssoooooso....',
    '.........oooooo...o.....',
    '........................',
  ],
);

export const charmAnchor = sprite(
  'charm_anchor',
  { o: 'ink', p: 'paper', s: 'steel', l: 'lilacGrey', d: 'dusk', r: 'rust', b: 'brick' },
  [
    '..........oooo..........',
    '.........oppppo.........',
    '........oppppllo........',
    '........oppoollo........',
    '........oplllllo........',
    '.....ooooollllooooo.....',
    '....opppppoooopppppo....',
    '...osssssssssssssbsso...',
    '....oddddddddddddddo....',
    '.....oooooooooooooo.....',
    '...o.....opsldo.....o...',
    '..oso....opsldo....olo..',
    '.opsso...opsrdo...osllo.',
    '.opsspo..opsldo..opsllo.',
    '.opssso..opsldo..ossllo.',
    'oppssso..opsldo..osslllo',
    '.ooopppo.opslbo.osslooo.',
    '...oppppoopsldoossllo...',
    '....osrppopsldosslbo....',
    '.....osssopsldolllo.....',
    '......oossoslolloo......',
    '........oooooooo........',
    '........................',
    '........................',
  ],
);

// ---- Legendary

export const charmMawsfavor = sprite(
  'charm_mawsfavor',
  {
    o: 'ink',
    w: 'white',
    G: 'lemon',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    k: 'brick',
    P: 'pinkLilac',
    v: 'lavender',
    V: 'violet',
    u: 'purple',
    n: 'aubergine',
    p: 'paper',
    W: 'wine',
  },
  [
    '...........oo...........',
    '..........oggo..........',
    '.........ogooao......w..',
    '....G...oooooooo........',
    '...GwGoollllggggoo......',
    '....Golllllllggggao.....',
    '....ollllloooogglaao....',
    '...olllloWwpwpWogaaao...',
    '...ollowppWWWWwwpoaao...',
    '..olllowppnnnnwwpoagco..',
    '..olloWwpnnnnnnwpWoaco..',
    '.oglloWwpnuvvunwpWoacco.',
    '.ogggWWnpnvPPvnwnWWccco.',
    '.oglgWWnnuvPvVunnWWcgko.',
    '.ogggoWWnnuVVunnWWoccko.',
    '..oggoWWnnnuunnnWWocco..',
    '..oagoWWWnpnnwnWWWocko..',
    '..oalaoWWwpnnwpWWocgko..',
    '...oaaaoWwpWWwpWockko...',
    '....oaaaooppwwoockko....',
    '.....ocgccccccckgko.....',
    '......occcccgkkkko......',
    '.......ookkkkkkoo.......',
    '.........oooooo.........',
  ],
);

export const charmHalofrag = sprite(
  'charm_halofrag',
  { o: 'ink', w: 'white', G: 'lemon', g: 'gold', a: 'amber', c: 'copper', P: 'pinkLilac', v: 'lavender' },
  [
    '........................',
    '......G.................',
    '.....GwG................',
    '......G.................',
    '..o......v.Pv.P.........',
    '.oGo...P........v.......',
    '.oao..v..........P......',
    '..o.o.............v.....',
    '..oogo.............P....',
    '.oGoao..................',
    '.oGaao..............v...',
    '.oGaao..............P...',
    '.oGaao..............v...',
    '.oGGgo..................',
    '.oagggo............P....',
    '..oggggoo......oo.v..o..',
    '..oaggGGGoooooowGo..ogo.',
    '...oagggGGGGwwwwgoo..o..',
    '....oaaaaaagaaaaoGgo....',
    '.....oaaaaaaaaacogao....',
    '......oooaaaaaco.oo.G...',
    '.........oooPoo....GwG..',
    '....................G...',
    '........................',
  ],
);

export const charmInfreceipt = sprite(
  'charm_infreceipt',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    G: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    v: 'lavender',
    V: 'violet',
    P: 'pinkLilac',
  },
  [
    '........................',
    '.....oooooooovooooooo...',
    '....owlwwwwwwwwwwwwwso..',
    '...olwwwlwwwwwwwwwwwsso.',
    '..owwwGwppppppppppppsso.',
    '..owwGcappppppppppppsso.',
    '..owwGcappppppppppppsso.',
    '..owwpapppssssssssssllo.',
    '...olppplsssssssssssllo.',
    '....oplplllllllllllllo..',
    '.....oooooooooooooooo...',
    '.v.....owpvvvvvvpso.....',
    '.......owpvvvvpppso..G..',
    '.......owppppppppso.GwG.',
    '.......owpGGppggpso..G..',
    '.......owGppggppaso.....',
    '...G...owgppgappaso.....',
    '..GwG..owpaappaapso.....',
    '...G...owppppppppso.....',
    '.......owpVVvvvvpso..P..',
    '.......owppppppppso.....',
    '.......owopopopopo......',
    '........o.o.o.o.o.......',
    '........................',
  ],
);

export const charmHeartmachine = sprite(
  'charm_heartmachine',
  {
    o: 'ink',
    w: 'white',
    G: 'lemon',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    k: 'brick',
    b: 'bronze',
    r: 'brass',
    p: 'paper',
    s: 'steel',
    L: 'lilacGrey',
    P: 'pinkLilac',
    v: 'lavender',
  },
  [
    '.......oooo...oooo......',
    '......ollaao.oggcco.....',
    '.......orco...obko..G...',
    '......ooocco.obooo.GwG..',
    '....oolllooo.ooggaooG...',
    '...ollllllloogggcaaao...',
    '..ollllllllooggggaaaao..',
    '..ollllllloppoggaaaaao..',
    '.ogllllllooppoogaaaaaco.',
    '.ogllllloppppssoaaacaco.',
    '.ogllggooppPPssooaaacco.',
    '..ogggopppPwvvLLLoaaco..',
    '..ogggopppPvvvLLLoacco..',
    '...ogggoossvvLLooacco...',
    '....oglgossLLLLoacco....',
    '.....oaaaooLLooacco.....',
    '......oaaaoLLoacco......',
    '.......oaaaooacco.......',
    '..v.....olaaccco........',
    '.........occcco.........',
    '..........occo..........',
    '..........okko..........',
    '...........oo...........',
    '........................',
  ],
);

export const charmSeventhseal = sprite(
  'charm_seventhseal',
  {
    o: 'ink',
    w: 'white',
    G: 'lemon',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    P: 'pinkLilac',
    v: 'lavender',
    V: 'violet',
    u: 'purple',
    n: 'aubergine',
  },
  [
    '........................',
    '...........oooo.........',
    '....G...oooPvvvo........',
    '...GwGooPPPPvvvvoo......',
    '....GoPPPPuuuuvvvVo.....',
    '....oPPPuuuuuuuuvVVo.w..',
    '....oPPuuGGllgguvVVo....',
    '...oPPPuuaaaagauvVVVo...',
    '...oPPuPvuuugauVVvVVuo..',
    '..ovvvuvvvvugauVVvVuo...',
    '..ovvvuvvvugauVVVvVuo...',
    '..ovvvuvvvugauVVVvuuo...',
    '...ovvuvvugauVVVVvuuno..',
    '...oVvvuVuuuuVVVvuunno..',
    '...oVVVuvVVVVVVvvuuoo...',
    '....oVVVvvvVVvvvuuno....',
    '.....oVVVVvvvvuunno.....',
    '......oouuuuuuunoo......',
    '......olooouunnoco......',
    '......olggaonnoaco......',
    '......olggaoooaaco......',
    '.....ollogaoogaoco......',
    '.....olo.oaoogo.oco.....',
    '......o...o..o...o......',
  ],
);

// ---- Cursed

export const charmCBloodnail = sprite(
  'charm_c_bloodnail',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    d: 'dusk',
    r: 'rust',
    b: 'brick',
    C: 'coral',
    R: 'red',
    B: 'blood',
    W: 'wine',
  },
  [
    '........................',
    '.......ooo..............',
    '......oppso.............',
    '.....oppslo.............',
    '....opbsllo.............',
    '...oppsllo..............',
    '..opwslldo..............',
    '.opwsllsldo.............',
    '.opsllppbldo............',
    '.osllooppsldo...........',
    '..ooo..oprsldo..........',
    '........oppbBWo.........',
    '.........opRRBWo........',
    '..........oCRRBWo.......',
    '...........oCRRBWo......',
    '............oCRRBWo.....',
    '............oBCRRBo.....',
    '............oBoCRRBo....',
    '.............o.oBRRo....',
    '................oooRo...',
    '...................oRo..',
    '...................oBo..',
    '....................o...',
    '........................',
  ],
);

export const charmCHungrycoin = sprite(
  'charm_c_hungrycoin',
  {
    o: 'ink',
    w: 'white',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    k: 'brick',
    e: 'cerise',
    C: 'crimson',
    W: 'wine',
    n: 'aubergine',
    f: 'flesh',
    R: 'red',
  },
  [
    '........................',
    '.........ooooo..........',
    '.......oolggggoo........',
    '......olllllggggoo......',
    '....ooollaaaaaggaao.....',
    '...olloeRollggaaaaao....',
    '..olllaoollgggggaaaao...',
    '..ollallloooooooooooo...',
    '.oglallloeeeeeeeeeeeeo..',
    '.oglalllonwwwnwwwnwwwo..',
    '.oglalggonnwnnnwnnnwno..',
    '.oggagggonnnnWWWWWWWWo..',
    '.oggagggonnnffRWWWWWWo..',
    '.oggagggonnnnwnnnwnnno..',
    '.oagagggonnnwwwnwwwnwo..',
    '.oaaaaaaoCCCCCCCCCCCCo..',
    '..oaaaaaaoooooooooooo...',
    '..oaaalaaaaaaccclkkko...',
    '...oaaallaacccllkkkoo...',
    '....occcclllllckkkoo....',
    '.....oocccccckkkoo......',
    '.......ookkkkkoo........',
    '.........ooooo..........',
    '........................',
  ],
);

export const charmCBlindfold = sprite(
  'charm_c_blindfold',
  {
    o: 'ink',
    n: 'night',
    d: 'dusk',
    l: 'lilacGrey',
    a: 'aubergine',
    e: 'cerise',
    C: 'crimson',
    R: 'red',
    B: 'blood',
  },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '.......o........o.......',
    '....oooloooooooolooo....',
    '...ollllllllllddddddo...',
    '..ollllllldndddddddddo..',
    '.oolllddddddnddddddnnoo.',
    'oodddRdRdddadddRnRnnnnoo',
    'ooddddRddddnnnnnRnnnnnoo',
    'oodddedennnnnnnenenaaaoo',
    '.oennnnnnnneCnnaaaaaaCo.',
    '..onnnnnnnnooaaaaaaaao..',
    '..oeennaaaeooCaaaaaCCo..',
    '...ooeeeeeo..oCCCCCoo...',
    '.....ooooo....ooRoo.....',
    '...............oBo......',
    '................o.......',
    '........................',
    '........................',
    '........................',
    '........................',
  ],
);

export const CHARM_SPRITES_R: SpriteDef[] = [
  charmGoldengrin,
  charmSecondmouth,
  charmCrookedlever,
  charmSurgeonkit,
  charmSandpendant,
  charmVoodoo,
  charmCrystalball,
  charmRatking,
  charmBloodbank,
  charmRecipe,
  charmVisor,
  charmPinball,
  charmWheelgrease,
  charmScratchcoin,
  charmAnchor,
  charmMawsfavor,
  charmHalofrag,
  charmInfreceipt,
  charmHeartmachine,
  charmSeventhseal,
  charmCBloodnail,
  charmCHungrycoin,
  charmCBlindfold,
];
